import React, { useContext, useState } from 'react'

import { Button as SlabButton } from 'slab'

import { MultistepFiltersContext } from './context'

interface ButtonProps
  extends Omit<React.ComponentProps<typeof SlabButton>, 'size' | 'variant'> {
  children: React.ReactNode;
}

export function Button ({ children, onClick, ...props }: ButtonProps) {
  const { setActiveFilter, setEditing } = useContext(MultistepFiltersContext)
  const [waiting, setWaiting] = useState(false)

  return (
    <div className='p-2 w-36'>
      <SlabButton
        {...props}
        disabled={props.disabled || waiting}
        onClick={async (event) => {
          setActiveFilter(null)
          setWaiting(true)
          await onClick?.(event)
          setWaiting(false)
          setEditing(false)
        }}
        size='large'
        variant='primary'
        width='full'
      >
        {children}
      </SlabButton>
    </div>
  )
}

Button.displayName = 'MultistepFilters.Button'
